import {
  Component,
  Input,
  OnInit,
} from '@angular/core';



/**
 * Badges are labels which hold small amounts of information.
 *
 * It supports several badge types.
 */
@Component({
  selector: 'clo-badge',
  templateUrl: './badge.html',
  styleUrls: ['./badge.scss']
})
export class CloBadge implements OnInit {

  /**
   * Type of the badge.
   *
   *  The following types are supported: `'success'`, `'error'`, `'new'`, `'compliant'`
   */
  @Input() type: string;


  ngOnInit() {
  }
}
